import { FormEvent, useState } from "react";
import { submitContactAPI } from "../../api/contact";
import AuthTextField from "../Form/AuthTextField";
import ErrorAlert from "../ErrorAlert/ErrorAlert";

const textareaClass =
  "w-full border px-3 py-2.5 text-sm rounded-sm focus:outline-none border-slate-300 bg-white text-slate-800 focus:ring-2 focus:ring-slate-400 focus:border-slate-400 resize-y min-h-[9rem]";

export const ContactForm: React.FC = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  function clearFeedback() {
    setSuccessMessage("");
    setErrorMessage("");
  }

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    clearFeedback();

    if (!name.trim() || !email.trim() || !message.trim()) {
      setErrorMessage("Please fill all required fields.");
      return;
    }
    if (!email.trim().includes("@")) {
      setErrorMessage("Please enter a valid email address.");
      return;
    }

    setIsSubmitting(true);
    try {
      const result = await submitContactAPI({
        name,
        email,
        subject,
        message,
        sourcePage: window.location.pathname,
      });

      if (result.ok) {
        setSuccessMessage(
          "Your message has been sent. We emailed you a confirmation and will reply soon.",
        );
        setName("");
        setEmail("");
        setSubject("");
        setMessage("");
      } else {
        setErrorMessage(result.message);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      onChange={clearFeedback}
      className="max-w-xl"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4">
        <AuthTextField
          label="Name *"
          value={name}
          onChange={setName}
          autoComplete="name"
          required
        />
        <AuthTextField
          label="Email *"
          type="email"
          value={email}
          onChange={setEmail}
          autoComplete="email"
          required
        />
      </div>

      <AuthTextField
        label="Subject"
        value={subject}
        onChange={setSubject}
      />

      <label className="block mb-4">
        <span className="block text-sm font-medium text-slate-700 mb-1.5">
          Message *
        </span>
        <textarea
          name="message"
          id="message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="How can we help?"
          rows={6}
          required
          className={textareaClass}
        />
      </label>

      {errorMessage && <ErrorAlert className="mb-4">{errorMessage}</ErrorAlert>}
      {successMessage && (
        <p className="text-sm text-green-700 bg-green-50 border border-green-200 rounded-sm p-3 mb-4">
          {successMessage}
        </p>
      )}

      <button
        type="submit"
        disabled={isSubmitting}
        className="eh-btn-primary px-6 py-2.5 text-sm font-medium disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {isSubmitting ? "Sending…" : "Send message"}
      </button>
    </form>
  );
};
